import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { compose, onlyUpdateForKeys } from 'recompose';
import { withStyles, Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import makeSelectorInstance from '../../reference/makeSelectorInstance';
import { transitionTypes, transitionTypesVar } from '../../reference/transitions';
import { getSelectedElements } from '../../banner/bannerSelectors';
import { setElementsTransitionOutType, setElementsTransitionOutDuration } from '../../banner/bannerActionsCreators';
import { styles } from '../propertyEditorStyles';
import { allElementsHasSameDeepProperty } from '../helpers';
import {
  toggleTransitionOutMenuOpen,
  getTemporaryTransitionOutMenuOpen,
} from '../../temporary-text-editor/temporaryTextEditorDucks';
import { getSelectedElementIds } from '../../temporary-status/temporaryStatusDucks';

const selectTransitionOutTypeInputPropId = { id: 'transition-out-type' };

class ElementsTransitionOutType extends React.Component {
  state = { classesState: {} };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { classes } = nextProps;
    return {
      ...prevState,
      classesState: {
        menuItem: { selected: classes.menuSelected, root: classes.menuItem },
      },
    };
  }

  onTransitionTypeChange = e => {
    const { setElementsTransitionOutType, setElementsTransitionOutDuration, ids } = this.props;
    setElementsTransitionOutType({ ids, type: e.target.value });
    if (e.target.value === transitionTypesVar.none) {
      setElementsTransitionOutDuration({ ids, duration: 0 });
    }
  };

  onOpen = () => {
    const { toggleTransitionOutMenuOpen } = this.props;
    toggleTransitionOutMenuOpen(true);
  };

  onClose = () => {
    const { toggleTransitionOutMenuOpen } = this.props;
    toggleTransitionOutMenuOpen(false);
  };

  render() {
    const { open, elements } = this.props;
    const { classesState } = this.state;
    return (
      <FormControl fullWidth>
        <InputLabel htmlFor="transition-out-type">
          <FormattedMessage id="properties.transition.type" />
        </InputLabel>
        <Select
          open={open}
          value={allElementsHasSameDeepProperty(elements, 'transitionOut', 'type') || ''}
          inputProps={selectTransitionOutTypeInputPropId}
          onChange={this.onTransitionTypeChange}
          onOpen={this.onOpen}
          onClose={this.onClose}
        >
          {transitionTypes.map(transition => (
            <MenuItem key={transition} value={transition} classes={classesState.menuItem}>
              <FormattedMessage id={`properties.transition.type.${transition}`} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

const makeStateToProps = () => state => ({
  elements: makeSelectorInstance(getSelectedElements)(state),
  ids: makeSelectorInstance(getSelectedElementIds)(state),
  open: makeSelectorInstance(getTemporaryTransitionOutMenuOpen)(state),
});

const dispatchToProps = {
  setElementsTransitionOutType,
  setElementsTransitionOutDuration,
  toggleTransitionOutMenuOpen,
};
export default compose(
  connect(
    makeStateToProps,
    dispatchToProps,
  ),
  onlyUpdateForKeys(['elements', 'open']),
  withStyles(styles),
)(ElementsTransitionOutType);
